import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import { useIntl } from 'react-intl';

import { TertiarySolidLink } from '@bibliocommons/base-links';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import { navMappedProps } from 'app/shapes/browse/rows';

import './Nav.scss';

// TODO: tracking is missing from router link
export default function Nav({ additionalAnalyticsPayload, links, trackClick }) {
  const intl = useIntl();
  const screenReaderPageTitle = intl.formatMessage({
    defaultMessage: 'Browse the library',
    id: 'browse.home.nav.title'
  });

  function renderNavLinks(link, index) {
    const itemPosition = index + 1; // 1-based count for analytics

    const { isRouterLink, title: linkText, url: linkUrl } = link;

    return (
      <li className="nav-item" key={linkText}>
        {isRouterLink ? (
          <Link
            className="nav-link"
            dataKey="nav-router-link"
            onClick={() => {
              trackClick({
                ...additionalAnalyticsPayload,
                itemPosition,
                linkText,
                linkUrl,
                uiContainerTitle: screenReaderPageTitle
              });
            }}
            to={linkUrl}
          >
            {linkText}
          </Link>
        ) : (
          <TertiarySolidLink
            className="nav-link"
            dataKey="nav-standard-link"
            handleClick={() =>
              trackClick({
                ...additionalAnalyticsPayload,
                itemPosition,
                linkText,
                linkUrl,
                uiContainerTitle: screenReaderPageTitle
              })}
            href={linkUrl}
            size="large"
          >
            {linkText}
          </TertiarySolidLink>
        )}
      </li>
    );
  }

  return (
    <>
      <div className="cp-browse-nav">
        <ScreenReaderMessage>
          <h2>{screenReaderPageTitle}</h2>
        </ScreenReaderMessage>
        <ul className="nav-row-contents">{links.map(renderNavLinks)}</ul>
      </div>
    </>
  );
}

Nav.defaultProps = {
  additionalAnalyticsPayload: {}
};

Nav.propTypes = {
  ...navMappedProps,
  additionalAnalyticsPayload: PropTypes.object,
  trackClick: PropTypes.func.isRequired
};
